import { Button } from '@invento/ui/components/button';
import { RouteState } from '@invento/ui/components/route-state';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { AppLayout } from '@/layout/app-layout';
import { ROUTE_PATHS } from '@/navigation/constants';
import { hasBusinessContext } from '@/core/auth/has-business-context';
import { useAuthStore } from '@/state/stores/auth.store';
import { buildLoginRecoveryPath, protectedRouteRecoveryReason } from '@/navigation/safe-return-target';

function InvalidRouteContent() {
  const navigate = useNavigate();

  return (
    <RouteState
      variant="invalid-route"
      title="We couldn’t find that page"
      description="The address may be mistyped or the link may be out of date."
      primaryAction={
        <Button type="button" size="dense" variant="primary" onClick={() => navigate(ROUTE_PATHS.HOME)}>
          Go to dashboard
        </Button>
      }
      secondaryAction={
        <Button type="button" size="dense" variant="secondary" onClick={() => navigate(-1)}>
          Go back
        </Button>
      }
      footer="If you followed a saved link, open the current page from the dashboard."
    />
  );
}

export function InvalidRoutePage() {
  const user = useAuthStore((state) => state.user);
  const accessToken = useAuthStore((state) => state.accessToken);
  const location = useLocation();

  if (accessToken && !user) {
    return (
      <Navigate
        to={buildLoginRecoveryPath({
          returnTo: `${location.pathname}${location.search}${location.hash}`,
          reason: protectedRouteRecoveryReason(location.pathname),
        })}
        replace
      />
    );
  }

  if (user && !hasBusinessContext(user)) {
    return <Navigate to={ROUTE_PATHS.ONBOARDING} replace />;
  }

  if (accessToken && hasBusinessContext(user)) {
    return (
      <AppLayout>
        <InvalidRouteContent />
      </AppLayout>
    );
  }

  return (
    <main className="min-h-dvh bg-[var(--a-page)] p-4 sm:p-6">
      <InvalidRouteContent />
    </main>
  );
}
